import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useEkengSettingsUpdate = () => {
  return useMutation({
    mutationFn: (data: any) => api.ekeng.updateSettings(data.id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось обновить настройки Ekeng',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Настройки успешно обновлены',
        type: 'success',
      })
    }
  })
}
